module.exports = __webpack_public_path__ + "img/tuyau_a.0e8d5a5b.svg";